module.exports = __webpack_public_path__ + "assets/img/2e.5d13b4c5.png";